import React from "react";
import { Modal, Tag, Divider, Space, Typography } from "antd";
import { ArrowRightOutlined } from "@ant-design/icons";
import moment from "moment";
import "./TransactionViewModal.css";
const { Text } = Typography;
const TransactionViewModal = ({ visible, onClose, data }) => {
  if (!data) return null;
  console.log("txn_data======>", data);

  const sender = data.sender;
  const receiver = data.receiver;

  const formatText = (text) =>
    text ? text.replaceAll("_", " ") : "N/A";

  return (
    <Modal
      title="Transaction Details"
      open={visible}
      onCancel={onClose}
      footer={null}
      width={900}
      centered
      className="transaction-view-modal"
    >
      {/* ================= Transaction Info ================= */}
      <Section title="Transaction Information">
        <Item label={<Text strong>Transaction ID</Text>} value={data.transaction_id} />

        <Item
          label={<Text strong>Transaction Type</Text>}
          value={
            <Tag color="blue">
              {data.service_type?.replaceAll("_", " ")}
            </Tag>
          }
        />

        <Item label={<Text strong>Amount</Text>} value={`NZ$ ${data.amount}`} />

        <Item label={<Text strong>Transaction Ref</Text>} value={data.reference_number} />

        <Item
          label={<Text strong>Transaction Date</Text>}
          value={moment(data.created_at).format("DD MMM YYYY, hh:mm A")}
        />

        <Item
          label={<Text strong>Status</Text>}
          value={
            <Tag
              color={
                data.status === "SUCCESS"
                  ? "green"
                  : data.status === "PENDING"
                    ? "gold"
                    : "red"
              }
            >
              {data.status}
            </Tag>
          }
        />

        {data.meta?.reason && (
          <Item
            label={<Text strong>Reason</Text>}
            value={data.meta.reason.replaceAll("_", " ")}
          />
        )}

        {data.meta?.note && (
          <Item
            label={<Text strong>Note</Text>}
            value={data.meta.note}
          />
        )}
      </Section>

      <Divider />

      {/* ================= Initiator ================= */}
      <Section title={<Text strong>Initiated By</Text>}>
        <Item label={<Text strong>Role</Text>} value={data.service_type == "ADMIN_CREDIT" ? "Admin" : (data.sender?.type ?? data.receiver?.type ?? "N/A")} />
        <Item
          label={<Text strong>Method</Text>}
          value={
            (data.from_method || data.to_method) ? (
              <Space>
                {data.from_method && <Tag>{data.from_method}</Tag>}
                <ArrowRightOutlined />
                {data.to_method && <Tag color="green">{data.to_method}</Tag>}
              </Space>
            ) : (
              "N/A"
            )
          }
        />
        <Item label={<Text strong>Service Type</Text>} value={data.service_type} />
      </Section>

      {sender && <Divider />}

      {/* ================= Beneficiary ================= */}
      {sender && <Section title={<Text strong>Sender</Text>}>
        <Item label={<Text strong>Type</Text>} value={sender?.type} />
        <Item label={<Text strong>Name</Text>} value={sender?.name} />
        <Item label={<Text strong>Email</Text>} value={sender?.email} />
        <Item label={<Text strong>Mobile</Text>} value={sender?.phone} />
        <Item
          label={<Text strong>Wallet Balance</Text>}
          value={
            sender?.balance !== undefined && sender?.balance !== null
              ? `NZ$ ${sender.balance}`
              : "N/A"
          }
        />
        <Item
          label={<Text strong>Status</Text>}
          value={
            <Tag color={sender?.status === "Active" ? "green" : "red"}>
              {sender?.status}
            </Tag>
          }
        />
      </Section>
      }
      {receiver && <Divider />}

      {receiver && <Section title={<Text strong>Receiver</Text>}>
        <Item label={<Text strong>Type</Text>} value={receiver?.type} />
        <Item label={<Text strong>Name</Text>} value={receiver?.name} />
        {receiver?.type !== "MERCHANT" && <Item label={<Text strong>Email</Text>} value={receiver?.email} />}
        {receiver?.type === "MERCHANT" && <Item label={<Text strong>NZBN</Text>} value={receiver?.merchant_code ?? "NA"} />}
        <Item label={<Text strong>Mobile</Text>} value={receiver?.phone} />
        <Item
          label={<Text strong>Wallet Balance</Text>}
          value={
            receiver?.balance !== undefined && receiver?.balance !== null
              ? `NZ$ ${receiver.balance}`
              : "N/A"
          }
        />
        <Item
          label={<Text strong>Status</Text>}
          value={
            <Tag color={receiver?.status === "Active" ? "green" : "red"}>
              {receiver?.status}
            </Tag>
          }
        />
      </Section>}
      {data.method === "BANK" && data.meta && (
        <>
          <Divider />
          <Section title={<Text strong>Bank Details</Text>}>
            <Item label={<Text strong>Bank Name</Text>} value={data.meta.bank_name} />
            <Item
              label={<Text strong>Account Number</Text>}
              value={`****${data.meta.account_number}`}
            />
          </Section>
        </>
      )}
    </Modal>
  );
};

export default TransactionViewModal;

/* ---------- Helpers ---------- */

const Section = ({ title, children }) => (
  <div className="section-card">
    <h3 className="section-title">{title}</h3>
    <div className="info-grid">{children}</div>
  </div>
);

const Item = ({ label, value }) => (
  <div className="info-item">
    <span className="info-label">{label}</span>
    <span className="info-value">{value || "N/A"}</span>
  </div>
);
